// action 
import OdataReadOnlyActionBase from "@/core/actions/OdataReadOnlyActionBase";
// service
import ClientPagesService from "@/cms/services/ClientPagesService";


class ClientPagesServiceAction extends OdataReadOnlyActionBase {

    constructor( dispatch: any, screenCode:string ) {
        super(dispatch, ClientPagesService, screenCode);
    }

}

export default ClientPagesServiceAction;
